import { schema } from 'normalizr';

export const filterSchema = new schema.Entity('filters', {});
export const arrayOfFilterSchemas = new schema.Array(filterSchema);



// WEBPACK FOOTER //
// ./src/schemas/filters.js